import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Blogs.css';
import { fetchJson } from '../../api';
import Loader from '../Loader/Loader';

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value.replace(' ', 'T'));
  if (isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

const Blogs = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    let mounted = true;

    fetchJson('blogs').then((data) => {
      if (mounted && data && Array.isArray(data.blogs)) {
        setPosts(data.blogs);
      } else if (mounted) {
        setPosts([]);
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="blogs-page">
      <Helmet>
        <title>Blog & Fertility Articles | Amaanat IVF Ambala</title>
        <meta
          name="description"
          content="Read fertility tips, IVF guides, success stories and clinic news from Amaanat IVF & Fertility Centre, Ambala."
        />
        <link rel="canonical" href="https://amaanativf.com/blogs" />
      </Helmet>

      {/* Hero */}
      <section className="blogs-hero">
        <div className="container">
          <h1 className="hero-title">Blogs & Articles</h1>
          <p className="hero-subtitle">
            Fertility tips, IVF guides, and news from Amaanat IVF
          </p>
        </div>
      </section>

      {/* Posts grid */}
      <section className="blogs-section">
        <div className="container">
          {posts === null ? (
            <Loader status="Loading articles" />
          ) : posts.length === 0 ? (
            <p className="blogs-loading">
              No articles published yet. Please check back soon.
            </p>
          ) : (
            <div className="blogs-grid">
              {posts.map((post) => (
                <article className="blog-card" key={post.id}>
                  <Link to={`/blogs/${post.slug}`} className="blog-card-image">
                    {post.cover_image_url ? (
                      <img src={post.cover_image_url} alt={post.title} loading="lazy" />
                    ) : (
                      <div className="blog-card-placeholder">🩺</div>
                    )}
                    {post.category && (
                      <span className="blog-card-category">{post.category}</span>
                    )}
                  </Link>

                  <div className="blog-card-body">
                    <p className="blog-card-meta">
                      {formatDate(post.published_at || post.created_at)}
                      {post.author ? ` • ${post.author}` : ''}
                    </p>

                    <h3 className="blog-card-title">
                      <Link to={`/blogs/${post.slug}`}>{post.title}</Link>
                    </h3>

                    {post.excerpt && (
                      <p className="blog-card-excerpt">{post.excerpt}</p>
                    )}

                    <Link to={`/blogs/${post.slug}`} className="blog-card-link">
                      Read More →
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Blogs;
